import React from 'react'
import { useAppSelector } from '../../../state/hooks'
import { View, Platform } from 'react-native'
import { Text } from '../../../components/DesignSystem'

export default function PrivacyPolicyContent({
	textSize = 'body',
}: {
	textSize?: 'body' | 'small'
}) {
	const { email } = useAppSelector(state => state.settings)

	const { loadedData } = useAppSelector(state => state.data)
	const orgName = loadedData[global.org].name
	const isWeb = Platform.OS === 'web'

	const url = loadedData[global.org]?.webURL || 'https://www.nextgenkitchens.com'
	const cleanUrl = url.replace(/^https?:\/\//, '')

	return (
		<View>
			<Text level={textSize}>
				{`I agree to receive SMS notifications from ${orgName} including order confirmations, delivery updates and account verification codes. Message frequency varies based on orders and account activity. Message and data rates may apply. Your mobile information will never be shared with third parties/affiliates for marketing purposes. Reply STOP to opt out or Contact ${email} for assistance. ${!isWeb ? `Visit ${cleanUrl} to view the privacy policy.` : ''}`}
			</Text>
		</View>
	)
}
